import { __awaiter, __generator, __read } from "tslib";
import { PlayerType } from '@sky-uk-ott/core-video-sdk-js-core';
import { loadTapeModule } from '@sky-uk-ott/core-video-sdk-js-core/lib/players/tape/tape-player-loader';
var importShaka = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ShakaPlayerEngineFactory;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import(
                /*  webpackChunkName: "sdk-player-shaka" */
                '@sky-uk-ott/core-video-sdk-js-core/lib/players/shaka')];
            case 1:
                ShakaPlayerEngineFactory = (_a.sent()).ShakaPlayerEngineFactory;
                return [2 /*return*/, ShakaPlayerEngineFactory];
        }
    });
}); };
var importHtml = function () { return __awaiter(void 0, void 0, void 0, function () {
    var HtmlVideoPlayerEngineFactory;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import(
                /*  webpackChunkName: "sdk-player-html-video" */ '@sky-uk-ott/core-video-sdk-js-core/lib/players/html-video')];
            case 1:
                HtmlVideoPlayerEngineFactory = (_a.sent()).HtmlVideoPlayerEngineFactory;
                return [2 /*return*/, HtmlVideoPlayerEngineFactory];
        }
    });
}); };
var importDual = function () { return __awaiter(void 0, void 0, void 0, function () {
    var DualPlayerEngineFactory;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import(
                /*  webpackChunkName: "sdk-player-dual-player" */
                '@sky-uk-ott/core-video-sdk-js-core/lib/players/dual-player')];
            case 1:
                DualPlayerEngineFactory = (_a.sent()).DualPlayerEngineFactory;
                return [2 /*return*/, DualPlayerEngineFactory];
        }
    });
}); };
export function loadPlayerEngineFactory(playerType, internalConfig, device, propositionPlayerConfig, propositionThumbnailConfig, propositionHighFramerateValue) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var devicesConfig, debugConfig, drmConfig, addonsConfig, playersConfig, _b, ShakaPlayerEngineFactory, _c, ShakaPlayerEngineFactory, HtmlVideoPlayerEngineFactory, DualPlayerEngineFactory, shakaFactory, htmlVideoFactory, dualPlayerFactory, AampPlayerEngineFactory, TheoPlayerEngineFactory, WebMafPlayerEngineFactory, YouViewPlayerEngineFactory, AndroidTvPlayerEngineFactory, _d, TapePlayerEngineFactory, tapeModule;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    devicesConfig = internalConfig.devices, debugConfig = internalConfig.debug, drmConfig = internalConfig.drm, addonsConfig = internalConfig.addons;
                    playersConfig = internalConfig.players;
                    _b = playerType;
                    switch (_b) {
                        case PlayerType.Shaka: return [3 /*break*/, 1];
                        case PlayerType.DualPlayer: return [3 /*break*/, 3];
                        case PlayerType.Aamp: return [3 /*break*/, 5];
                        case PlayerType.Theo: return [3 /*break*/, 7];
                        case PlayerType.WebMaf: return [3 /*break*/, 9];
                        case PlayerType.YouView: return [3 /*break*/, 11];
                        case PlayerType.Android: return [3 /*break*/, 13];
                        case PlayerType.Tape: return [3 /*break*/, 15];
                    }
                    return [3 /*break*/, 17];
                case 1: return [4 /*yield*/, importShaka()];
                case 2:
                    ShakaPlayerEngineFactory = _e.sent();
                    return [2 /*return*/, new ShakaPlayerEngineFactory(playersConfig.shaka, device, debugConfig, drmConfig, propositionPlayerConfig === null || propositionPlayerConfig === void 0 ? void 0 : propositionPlayerConfig[PlayerType.Shaka], propositionThumbnailConfig, propositionHighFramerateValue)];
                case 3: return [4 /*yield*/, Promise.all([
                        importShaka(),
                        importHtml(),
                        importDual(),
                    ])];
                case 4:
                    _c = __read.apply(void 0, [_e.sent(), 3]), ShakaPlayerEngineFactory = _c[0], HtmlVideoPlayerEngineFactory = _c[1], DualPlayerEngineFactory = _c[2];
                    shakaFactory = new ShakaPlayerEngineFactory(playersConfig.shaka, device, debugConfig, undefined, propositionPlayerConfig === null || propositionPlayerConfig === void 0 ? void 0 : propositionPlayerConfig[PlayerType.Shaka]);
                    htmlVideoFactory = new HtmlVideoPlayerEngineFactory();
                    dualPlayerFactory = new DualPlayerEngineFactory(shakaFactory, htmlVideoFactory);
                    return [2 /*return*/, dualPlayerFactory];
                case 5: return [4 /*yield*/, import(
                    /*  webpackChunkName: "sdk-player-aamp" */ '@sky-uk-ott/core-video-sdk-js-core/lib/players/aamp')];
                case 6:
                    AampPlayerEngineFactory = (_e.sent()).AampPlayerEngineFactory;
                    return [2 /*return*/, new AampPlayerEngineFactory(playersConfig.aamp, device.deviceInfo, devicesConfig === null || devicesConfig === void 0 ? void 0 : devicesConfig.xfinity)];
                case 7: return [4 /*yield*/, import(
                    /*  webpackChunkName: "sdk-player-theo" */ '@sky-uk-ott/core-video-sdk-js-core/lib/players/theo')];
                case 8:
                    TheoPlayerEngineFactory = (_e.sent()).TheoPlayerEngineFactory;
                    return [2 /*return*/, new TheoPlayerEngineFactory(device.deviceInfo, playersConfig.theo, debugConfig)];
                case 9: return [4 /*yield*/, import(
                    /*  webpackChunkName: "sdk-player-webmaf" */ '@sky-uk-ott/core-video-sdk-js-core/lib/players/webmaf')];
                case 10:
                    WebMafPlayerEngineFactory = (_e.sent()).WebMafPlayerEngineFactory;
                    return [2 /*return*/, new WebMafPlayerEngineFactory(playersConfig.webMaf, device.bridge)];
                case 11: return [4 /*yield*/, import(
                    /*  webpackChunkName: "sdk-player-youview" */ '@sky-uk-ott/core-video-sdk-js-core/lib/players/youview')];
                case 12:
                    YouViewPlayerEngineFactory = (_e.sent()).YouViewPlayerEngineFactory;
                    return [2 /*return*/, new YouViewPlayerEngineFactory(addonsConfig.reporting.nativeReporting, device)];
                case 13: return [4 /*yield*/, import(
                    /*  webpackChunkName: "sdk-player-androidtv" */ '@sky-uk-ott/core-video-sdk-js-core/lib/players/android-tv')];
                case 14:
                    AndroidTvPlayerEngineFactory = (_e.sent()).AndroidTvPlayerEngineFactory;
                    // @ts-ignore
                    return [2 /*return*/, new AndroidTvPlayerEngineFactory(playersConfig.androidTv, device, device.bridge)];
                case 15: return [4 /*yield*/, Promise.all([
                        import(/*  webpackChunkName: "sdk-player-tape" */ '@sky-uk-ott/core-video-sdk-js-core/lib/players/tape'),
                        loadTapeModule(playersConfig.tape, device, ((_a = propositionPlayerConfig === null || propositionPlayerConfig === void 0 ? void 0 : propositionPlayerConfig[PlayerType.Tape]) === null || _a === void 0 ? void 0 : _a.subtitlesFormat) || []),
                    ])];
                case 16:
                    _d = __read.apply(void 0, [_e.sent(), 2]), TapePlayerEngineFactory = _d[0].TapePlayerEngineFactory, tapeModule = _d[1];
                    return [2 /*return*/, new TapePlayerEngineFactory(playersConfig.tape, tapeModule, device)];
                case 17: return [2 /*return*/, Promise.reject(new Error("Player Type not handled: ".concat(playerType)))];
            }
        });
    });
}
//# sourceMappingURL=load-player-engine-factory.js.map